// Activate first slide immediately — no waiting for DOM event
(function() {
  var firstSlide = document.querySelector("#andern-hero .andern-hero__slide");
  if (firstSlide) firstSlide.classList.add("active");
})();

document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll("#andern-hero .andern-hero__slide");
  if (!slides.length) return;

  let current = 0;

  const switchSlide = () => {
    slides[current].classList.remove("active");
    current = (current + 1) % slides.length;
    slides[current].classList.add("active");
  };

  // Smooth fade rotation
  setInterval(switchSlide, 7000);

  // Gentle parallax drift for cinematic feel
  slides.forEach(slide => {
    slide.animate(
      [
        { transform: "scale(1.05) translateX(-2%)" },
        { transform: "scale(1.05) translateX(2%)" },
        { transform: "scale(1.05) translateX(-2%)" }
      ],
      {
        duration: 18000,
        iterations: Infinity,
        easing: "ease-in-out"
      }
    );
  });
});